module.exports = __webpack_public_path__ + "static/media/squirrel3-min.efa29b6a.png";